const emailValidationRegex = /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/

export function validateEmail(str) {
    if(str != null && str != '') return emailValidationRegex.test(str);
    return false
}